<template>
    <div v-if="linkedUsers.length" class="card mt-2">
        <div class="card-header">
            <router-link
                :to="{ name: 'manage_linked_accounts' }"
            >
                <h6 class="card-subtitle">
                    <font-awesome-icon icon="link" class="mr-2" />
                    Linked Accounts
                </h6>
            </router-link>
            <span class="text-muted">Select an account to change accounts.</span>
        </div>
        <div class="card-body card-scroll text-center">
            <div class="d-flex flex-wrap justify-content-center">
                <div
                    v-for="user in linkedUsers"
                    :key="user.id"
                    class="d-flex flex-column align-items-center p-3"
                >
                    <b-avatar></b-avatar>
                    <button
                        class="btn btn-link"
                        @click="switchAccount(user.id)"
                    >
                        {{ user.person.first_name }} {{ user.person.last_name }} &rsaquo;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            linkedUsers: [],
            selectedUserId: 0
        };
    },
    mounted() {
        this.loadLinkedUsers();
    },
    methods: {
        loadLinkedUsers() {
            this.$api.get(
                "/api/account/linked-accounts"
            ).then(({ data: { records } }) => {
                this.linkedUsers = records || [];
            });
        },
        switchAccount(user_id) {
            this.$api.get(
                "/api/account/switch-account",
                {
                    params: { user_id }
                }
            ).then(({ data: { message, token } }) => {
                if (!token) {
                    alert(message);
                } else {
                    localStorage.setItem("token", token);
                    window.location.reload();
                }
            });
        }
    },
    computed: {
        linkedUser() {
            return this.linkedUsers[0];
        },
        selectedUser() {
            return this.linkedUsers.find((user) => user.id == this.selectedUserId);
        }
    }
}
</script>